// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   HealthMonitorApp.css - Medical AI Theme
   ============================================ */

.hm-app {
  background: #F8FAFC;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

.hm-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 1.5rem;
}

/* Hero */
.hm-hero {
  text-align: center;
  padding: 1.5rem 0 1rem;
}

.hm-hero-icon {
  width: 56px;
  height: 56px;
  border-radius: 1rem;
  background: linear-gradient(135deg, #0F766E, #14B8A6);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-bottom: 0.75rem;
  box-shadow: 0 8px 20px rgba(15, 118, 110, 0.25);
  animation: heroFloat 3s ease-in-out infinite;
}

@keyframes heroFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

/* ============================================
   Camera Loading
   ============================================ */
.hm-camera-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 1rem;
  gap: 1.25rem;
}
.hm-loading-spinner {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 4px solid #E2E8F0;
  border-top-color: #0F766E;
  animation: spin 0.8s linear infinite;
}
.hm-loading-text {
  font-size: 1rem;
  font-weight: 600;
  color: #475569;
}

/* ============================================
   Camera Fade In / Video Fade In
   ============================================ */
.hm-camera-enter {
  animation: cameraFadeIn 700ms ease forwards;
}
.hm-video-enter {
  animation: videoFadeIn 700ms ease forwards;
}
@keyframes cameraFadeIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}
@keyframes videoFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* ============================================
   Camera Border Gradient
   ============================================ */
.hm-camera-border {
  position: absolute;
  inset: -2px;
  border-radius: inherit;
  z-index: 1;
  pointer-events: none;
}
.hm-camera-border::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 2px;
  background: conic-gradient(from 0deg, transparent, rgba(20,184,166,0.3), transparent, rgba(20,184,166,0.7), transparent);
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  animation: borderRotate 4s linear infinite;
}
@keyframes borderRotate {
  to { transform: rotate(360deg); }
}
.hm-border-pulse::before {
  animation: borderRotate 4s linear infinite, borderPulse 2s ease-in-out infinite;
}
@keyframes borderPulse {
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
}

.hm-hero-title {
  font-size: 2rem;
  font-weight: 800;
  color: #0F172A;
  letter-spacing: -0.5px;
}

.hm-hero-sub {
  font-size: 0.9375rem;
  color: #64748B;
  margin-top: 0.25rem;
}

/* Error */
.hm-error {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  background: #FEF2F2;
  border: 1px solid #FECACA;
  border-radius: 0.75rem;
  margin-bottom: 1.25rem;
  color: #DC2626;
}

.hm-error svg { flex-shrink: 0; margin-top: 2px; }
.hm-error-title { font-weight: 600; font-size: 0.875rem; }
.hm-error-msg { font-size: 0.8125rem; color: #B91C1C; margin-top: 2px; }

/* ============================================
   Idle State
   ============================================ */

.hm-idle {
  text-align: center;
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 1rem;
  padding: 3rem 2rem;
}

.hm-idle-icon-wrap {
  position: relative;
  display: inline-block;
  margin-bottom: 1.5rem;
}

.hm-idle-icon-bg {
  position: absolute;
  inset: -8px;
  background: linear-gradient(135deg, #CCFBF1, #99F6E4);
  border-radius: 50%;
  opacity: 0.5;
  animation: iconPulse 2.5s ease-in-out infinite;
}

@keyframes iconPulse {
  0%, 100% { transform: scale(1); opacity: 0.5; }
  50% { transform: scale(1.1); opacity: 0.3; }
}

.hm-idle-icon {
  position: relative;
  color: #0F766E;
}

.hm-idle-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0F172A;
  margin-bottom: 0.5rem;
}

.hm-idle-desc {
  color: #64748B;
  font-size: 0.9375rem;
  max-width: 480px;
  margin: 0 auto 1.75rem;
  line-height: 1.65;
}

/* Features Grid */
.hm-features {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-top: 2rem;
}

.hm-feature {
  padding: 1.25rem;
  background: #F8FAFC;
  border: 1px solid #F1F5F9;
  border-radius: 0.75rem;
  transition: all 0.25s ease;
}

.hm-feature:hover {
  background: #fff;
  border-color: #E2E8F0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transform: translateY(-2px);
}

.hm-feature-icon {
  width: 40px;
  height: 40px;
  border-radius: 0.625rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 0.75rem;
}

.hm-feature-1 { background: #FEF2F2; color: #DC2626; }
.hm-feature-2 { background: #EFF6FF; color: #2563EB; }
.hm-feature-3 { background: #F5F3FF; color: #7C3AED; }
.hm-feature-4 { background: #FFFBEB; color: #D97706; }

.hm-feature-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #0F172A;
  margin-bottom: 0.25rem;
}

.hm-feature-desc {
  font-size: 0.75rem;
  color: #64748B;
}

/* ============================================
   Buttons
   ============================================ */

.hm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border-radius: 0.625rem;
  font-size: 0.9375rem;
  font-weight: 600;
  font-family: 'Inter', system-ui, sans-serif;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
}

.hm-btn-primary {
  background: linear-gradient(135deg, #0F766E, #0D9488);
  color: #fff;
  box-shadow: 0 4px 14px rgba(15, 118, 110, 0.3);
}

.hm-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(15, 118, 110, 0.4);
}

.hm-btn-secondary {
  background: #F1F5F9;
  color: #475569;
  border: 1px solid #E2E8F0;
}

.hm-btn-secondary:hover {
  background: #E2E8F0;
}

.hm-btn-record {
  background: linear-gradient(135deg, #DC2626, #B91C1C);
  color: #fff;
  box-shadow: 0 4px 14px rgba(220, 38, 38, 0.3);
}

.hm-btn-record:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(220, 38, 38, 0.4);
}

.hm-btn-group {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
}

.hm-record-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
}

/* ============================================
   Camera State
   ============================================ */

.hm-camera, .hm-recording {
  position: relative;
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 1rem;
  overflow: hidden;
}

/* Instruction Banner */
.hm-instruction-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  width: fit-content;
  margin: 1rem auto;
  padding: 1rem 2rem;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  font-weight: 500;
  font-size: 1rem;
  color: #0F172A;
  animation: slideUpFadeIn 0.5s ease forwards;
}

.hm-instruction-icon {
  font-size: 1.5rem;
  line-height: 1;
}

.hm-instruction-text {
  animation: slideUpFadeIn 0.5s ease forwards;
}

@keyframes slideUpFadeIn {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes slideUpFadeOut {
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(-8px); }
}

/* Watermark Logo */
.hm-watermark {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  width: 64px;
  height: 64px;
  opacity: 0.35;
  pointer-events: none;
  z-index: 5;
}

.hm-hint-banner {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem;
  background: #FEF3C7;
  border: 1px solid #FDE68A;
  border-radius: 0.625rem;
  margin-bottom: 0.75rem;
  font-size: 0.8125rem;
  color: #92400E;
  line-height: 1.5;
}

.hm-hint-banner svg {
  flex-shrink: 0;
  color: #D97706;
  margin-top: 2px;
}

.hm-video-wrap {
  position: relative;
  background: #000;
}

.hm-video {
  width: 100%;
  height: 420px;
  object-fit: cover;
  display: block;
}

.hm-video-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.hm-face-guide {
  width: 16rem;
  height: 20rem;
  border: 3px solid rgba(20, 184, 166, 0.5);
  border-radius: 50%;
  animation: guidePulse 2.5s ease-in-out infinite;
  transition: all 0.3s ease;
}

.hm-face-guide.face-detected {
  border-color: rgba(20, 184, 166, 0.8);
  box-shadow: 0 0 20px rgba(20, 184, 166, 0.3), 0 0 40px rgba(20, 184, 166, 0.1);
  animation: guideDetected 2s ease-in-out infinite;
}

.hm-face-guide.face-not-detected {
  border-color: rgba(148, 163, 184, 0.4);
  box-shadow: none;
  animation: guideNotFound 2s ease-in-out infinite;
}

.hm-face-guide.face-recording {
  border-color: rgba(239, 68, 68, 0.6);
  box-shadow: 0 0 15px rgba(239, 68, 68, 0.3);
  animation: recGlow 2s ease-in-out infinite;
}

@keyframes guidePulse {
  0%, 100% { border-color: rgba(20, 184, 166, 0.5); }
  50% { border-color: rgba(20, 184, 166, 0.2); }
}

@keyframes guideDetected {
  0%, 100% { transform: scale(1); box-shadow: 0 0 20px rgba(20, 184, 166, 0.3), 0 0 40px rgba(20, 184, 166, 0.1); }
  50% { transform: scale(1.02); box-shadow: 0 0 30px rgba(20, 184, 166, 0.2), 0 0 50px rgba(20, 184, 166, 0.05); }
}

@keyframes guideNotFound {
  0%, 100% { border-color: rgba(148, 163, 184, 0.4); }
  50% { border-color: rgba(148, 163, 184, 0.15); }
}

@keyframes recGlow {
  0%, 100% { box-shadow: 0 0 15px rgba(239, 68, 68, 0.3); }
  50% { box-shadow: 0 0 25px rgba(239, 68, 68, 0.1); }
}

/* Looking for face */
.hm-looking-text {
  position: absolute;
  bottom: 3rem;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.875rem;
  font-weight: 500;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  padding: 0.5rem 1.25rem;
  border-radius: 2rem;
  white-space: nowrap;
  animation: pulseText 2s ease-in-out infinite;
  z-index: 10;
}

@keyframes pulseText {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}

/* Scan Ready Overlay */
.hm-scan-ready {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  z-index: 20;
  animation: scanReadyFade 2.2s ease forwards;
}
.hm-scan-ready-inner {
  text-align: center;
  color: #fff;
  animation: scanReadyScale 0.5s ease;
}
.hm-ready-checkmark {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(16, 185, 129, 0.2);
  border: 3px solid rgba(16, 185, 129, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 0.75rem;
}
.hm-check-path {
  stroke-dasharray: 30;
  stroke-dashoffset: 30;
  animation: drawCheck 0.6s ease forwards 0.1s;
}
@keyframes drawCheck {
  to { stroke-dashoffset: 0; }
}
.hm-ready-text {
  font-size: 1.125rem;
  font-weight: 700;
}
@keyframes scanReadyScale {
  from { transform: scale(0.8); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
@keyframes scanReadyFade {
  0%, 60% { opacity: 1; }
  100% { opacity: 0; }
}

/* Countdown Overlay */
.hm-countdown-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 25;
  background: rgba(0, 0, 0, 0.2);
}
.hm-countdown-number {
  font-size: 6rem;
  font-weight: 800;
  color: #fff;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  animation: countdownPop 1s ease forwards;
}
@keyframes countdownPop {
  0% { transform: scale(1.5); opacity: 0; }
  40% { transform: scale(1); opacity: 1; }
  100% { transform: scale(0.8); opacity: 0; }
}

/* Recording Complete */
.hm-recording-complete {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 1rem;
  animation: completeFade 1.5s ease forwards;
}
.hm-complete-inner {
  text-align: center;
  animation: completeScale 0.5s ease;
}
.hm-complete-check {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(16, 185, 129, 0.15);
  border: 3px solid #10B981;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 0.75rem;
}
.hm-complete-check .hm-check-path {
  stroke-dasharray: 30;
  stroke-dashoffset: 30;
  animation: drawCheck 0.6s ease forwards 0.1s;
}
.hm-complete-text {
  font-size: 1.25rem;
  font-weight: 700;
  color: #059669;
}
@keyframes completeScale {
  from { transform: scale(0.8); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
@keyframes completeFade {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

/* Timer */
.hm-timer-val {
  font-variant-numeric: tabular-nums;
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

.hm-badge {
  position: absolute;
  top: 1rem;
  left: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  color: #fff;
  padding: 0.375rem 0.875rem;
  border-radius: 2rem;
  font-size: 0.8125rem;
  font-weight: 500;
}

.hm-badge-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #10B981;
  animation: dotPulse 2s ease-in-out infinite;
}

.hm-badge-dot-red {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #EF4444;
  animation: dotPulse 1s ease-in-out infinite;
}

@keyframes dotPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

.hm-timer-overlay {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 0.5rem 1rem;
  border-radius: 2rem;
  font-size: 0.875rem;
}

.hm-timer-val {
  font-size: 1.25rem;
  font-weight: 700;
}

.hm-timer-total {
  color: #94A3B8;
}

.hm-camera-controls {
  padding: 1.25rem;
  text-align: center;
}

.hm-camera-hint {
  color: #475569;
  font-size: 0.9375rem;
  font-weight: 500;
  margin-bottom: 1rem;
}

/* Recording */
.hm-recording .hm-video {
  height: 380px;
}

.hm-recording-hint {
  text-align: center;
  color: #64748B;
  font-size: 0.875rem;
  padding: 0.75rem;
}

/* Progress Bar */
.hm-progress-wrap {
  padding: 0 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.hm-progress-bar {
  flex: 1 1;
  height: 6px;
  background: #E2E8F0;
  border-radius: 3px;
  overflow: hidden;
}

.hm-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #0F766E, #14B8A6);
  border-radius: 3px;
  transition: width 0.5s ease;
}

.hm-progress-animated {
  background: linear-gradient(90deg, #0F766E, #14B8A6, #0F766E);
  background-size: 200% 100%;
  animation: progressShimmer 2s linear infinite;
}

@keyframes progressShimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.hm-progress-text {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #475569;
  min-width: 3rem;
}

/* ============================================
   Processing State
   ============================================ */

.hm-processing {
  text-align: center;
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 1rem;
  padding: 3rem 2rem;
}

.hm-processing-spinner {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #F0FDF4, #CCFBF1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.25rem;
}

.hm-spin-icon {
  color: #0F766E;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.hm-processing-title {
  font-size: 1.375rem;
  font-weight: 700;
  color: #0F172A;
  margin-bottom: 0.375rem;
}

.hm-processing-desc {
  color: #64748B;
  font-size: 0.9375rem;
  margin-bottom: 1.5rem;
}

.hm-elapsed {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  color: #94A3B8;
  font-size: 0.8125rem;
  margin-top: 0.75rem;
}

/* ============================================
   Results State
   ============================================ */

.hm-results {
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 1rem;
  padding: 2rem;
}

.hm-results-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.hm-success-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #F0FDF4;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 0.75rem;
  color: #059669;
}

.hm-results-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0F172A;
  margin-bottom: 0.25rem;
}

.hm-results-sub {
  font-size: 0.9375rem;
  color: #64748B;
}

/* Patient Info Banner */
.hm-patient-info {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  background: #F0FDF4;
  border: 1px solid #A7F3D0;
  border-radius: 0.75rem;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  font-size: 0.9375rem;
  color: #0F172A;
}

.hm-patient-info-name {
  font-weight: 700;
  color: #0F766E;
}

.hm-patient-info-sep {
  color: #94A3B8;
}

/* Vital Cards Grid */
.hm-results-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.hm-vital-card {
  padding: 1.25rem;
  border-radius: 0.875rem;
  border: 1px solid #E2E8F0;
  background: #fff;
  transition: all 0.25s ease;
}

.hm-vital-card:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.hm-vital-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.hm-vital-card-1 .hm-vital-header svg { color: #DC2626; }
.hm-vital-card-2 .hm-vital-header svg { color: #F97316; }
.hm-vital-card-3 .hm-vital-header svg { color: #10B981; }
.hm-vital-card-4 .hm-vital-header svg { color: #3B82F6; }
.hm-vital-card-5 .hm-vital-header svg { color: #8B5CF6; }
.hm-vital-card-6 .hm-vital-header svg { color: #F59E0B; }
.hm-vital-card-7 .hm-vital-header svg { color: #EC4899; }
.hm-vital-card-8 .hm-vital-header svg { color: #6366F1; }

.hm-status-badge {
  font-size: 0.6875rem;
  padding: 0.2rem 0.5rem;
  border-radius: 2rem;
  font-weight: 600;
}

.status-normal { background: #F0FDF4; color: #059669; }
.status-warning { background: #FEF3C7; color: #D97706; }
.status-info { background: #EFF6FF; color: #2563EB; }
.status-muted { background: #F1F5F9; color: #94A3B8; }

.hm-vital-label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 0.25rem;
}

.hm-vital-value {
  display: flex;
  align-items: baseline;
  gap: 0.375rem;
}

.hm-vital-number {
  font-size: 1.75rem;
  font-weight: 800;
  color: #0F172A;
  letter-spacing: -0.5px;
}

.hm-vital-unit {
  font-size: 0.8125rem;
  color: #94A3B8;
  font-weight: 500;
}

/* ============================================
   Radar Chart Section
   ============================================ */
.hm-radar-section {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 0.875rem;
  padding: 1.5rem;
}
.hm-radar-polygon {
  opacity: 0;
  animation: hmRadarGrow 1.5s ease-out 0.2s forwards;
}
@keyframes hmRadarGrow {
  from { opacity: 0; }
  to { opacity: 1; }
}
@media (prefers-reduced-motion: reduce) {
  .hm-radar-polygon { animation: none; opacity: 1; }
}
.hm-radar-chart-wrap {
  flex: 0 0 60%;
}
.hm-radar-title {
  font-size: 1.0625rem;
  font-weight: 700;
  color: #0F172A;
  margin-bottom: 0.25rem;
}
.hm-radar-sub {
  font-size: 0.8125rem;
  color: #94A3B8;
  margin-bottom: 0.75rem;
}
.hm-summary-wrap {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 1.5rem;
  border-left: 1px solid #E2E8F0;
}
.hm-summary-title {
  font-size: 1.0625rem;
  font-weight: 700;
  color: #0F172A;
  margin-bottom: 0.75rem;
}
.hm-summary-list {
  list-style: none;
  padding: 0;
  margin: 0 0 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.hm-summary-item {
  position: relative;
  padding-left: 1.25rem;
  font-size: 0.8125rem;
  color: #475569;
  line-height: 1.5;
}
.hm-summary-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 7px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0F766E;
  opacity: 0.6;
}
.hm-wellness-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  margin: 0 auto 0.5rem;
}
.hm-wellness-ring {
  position: absolute;
  inset: 0;
}
.hm-wellness-score {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
}
.hm-wellness-num {
  font-size: 2rem;
  font-weight: 800;
  color: #0F172A;
}
.hm-wellness-total {
  font-size: 0.75rem;
  color: #94A3B8;
  font-weight: 600;
}
.hm-wellness-label {
  text-align: center;
  font-size: 0.75rem;
  color: #94A3B8;
  font-weight: 500;
}

/* Radar Tooltip */
.hm-radar-tooltip {
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 0.625rem;
  padding: 0.75rem 1rem;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  max-width: 200px;
}
.hm-rt-icon {
  font-size: 1.25rem;
  margin-bottom: 0.25rem;
}
.hm-rt-name {
  font-size: 0.875rem;
  font-weight: 700;
  color: #0F172A;
  margin-bottom: 0.25rem;
}
.hm-rt-value {
  font-size: 1.25rem;
  font-weight: 800;
  color: #0F172A;
}
.hm-rt-unit {
  font-size: 0.75rem;
  color: #94A3B8;
  font-weight: 500;
}
.hm-rt-status {
  font-size: 0.75rem;
  color: #64748B;
  margin-top: 0.25rem;
}
.hm-rt-badge { display: inline-block; padding: 0.1rem 0.4rem; border-radius: 0.25rem; font-weight: 600; font-size: 0.6875rem; }
.hm-rt-normal { background: #F0FDF4; color: #059669; }
.hm-rt-elevated { background: #FEF3C7; color: #D97706; }
.hm-rt-low { background: #FEF2F2; color: #DC2626; }
.hm-rt-excellent { background: #ECFDF5; color: #047857; }
.hm-rt-fair { background: #FFFBEB; color: #B45309; }
.hm-rt-range {
  font-size: 0.6875rem;
  color: #94A3B8;
  margin-top: 0.25rem;
}

/* Scan Details */
.hm-scan-details {
  background: #F8FAFC;
  border: 1px solid #F1F5F9;
  border-radius: 0.75rem;
  padding: 1.25rem;
  margin-bottom: 1.25rem;
}

.hm-scan-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #0F172A;
  margin-bottom: 0.75rem;
}

.hm-scan-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

.hm-scan-label {
  font-size: 0.75rem;
  color: #94A3B8;
  margin-bottom: 0.125rem;
}

.hm-scan-val {
  font-size: 0.9375rem;
  font-weight: 700;
  color: #0F172A;
}

/* Disclaimer Banner */
.hm-disclaimer-banner {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  background: #FFFBEB;
  border: 1px solid #FDE68A;
  border-radius: 0.75rem;
  margin-bottom: 1.25rem;
}

.hm-disclaimer-banner svg {
  flex-shrink: 0;
  color: #D97706;
  margin-top: 2px;
}

.hm-disclaimer-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #78350F;
  margin-bottom: 0.25rem;
}

.hm-disclaimer-text {
  font-size: 0.8125rem;
  color: #92400E;
  line-height: 1.6;
}

/* New Scan */
.hm-new-scan {
  text-align: center;
}


/* ============================================
   Responsive
   ============================================ */

@media (max-width: 1024px) {
  .hm-results-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .hm-scan-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .hm-radar-section {
    flex-direction: column;
  }
  .hm-radar-chart-wrap {
    flex: none;
  }
  .hm-summary-wrap {
    padding-left: 0;
    border-left: none;
    border-top: 1px solid #E2E8F0;
    padding-top: 1.25rem;
  }
}

@media (max-width: 768px) {
  .hm-features {
    grid-template-columns: repeat(2, 1fr);
  }
  .hm-video {
    height: 300px;
  }
  .hm-face-guide {
    width: 12rem;
    height: 16rem;
  }
  .hm-results {
    padding: 1.25rem;
  }
}

@media (max-width: 480px) {
  .hm-features {
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;
  }
  .hm-results-grid {
    grid-template-columns: 1fr;
  }
  .hm-scan-grid {
    grid-template-columns: 1fr 1fr;
  }
  .hm-video {
    height: 250px;
  }
}
/* ============================================
   Generate Report Button
   ============================================ */

.hm-report-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  padding: 1rem 0 0.25rem;
}

.hm-report-patient {
  font-size: 0.8125rem;
  color: #64748B;
}

.hm-report-patient strong {
  color: #0F172A;
}

.grp-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
}

.grp-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  padding: 0.85rem 1.75rem;
  background: linear-gradient(135deg, #0F766E, #0D9488);
  color: #fff;
  border: none;
  border-radius: 0.875rem;
  font-family: inherit;
  font-size: 0.9375rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(15, 118, 110, 0.3);
  transition: opacity 0.2s, transform 0.15s;
}

.grp-btn:hover:not(:disabled) {
  opacity: 0.92;
  transform: translateY(-1px);
}

.grp-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.grp-spin {
  animation: hmSpin 0.8s linear infinite;
}

@keyframes hmSpin {
  to { transform: rotate(360deg); }
}

.grp-msg {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.8125rem;
  font-weight: 500;
  padding: 0.5rem 0.9rem;
  border-radius: 0.5rem;
}

.grp-msg.success {
  background: #F0FDF4;
  border: 1px solid #BBF7D0;
  color: #047857;
}

.grp-msg.error {
  background: #FEF2F2;
  border: 1px solid #FECACA;
  color: #DC2626;
}
`, "",{"version":3,"sources":["webpack://./src/component/HealthMonitorApp.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,2CAA2C;AAC7C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;AACA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;;iDAEiD;AACjD;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,wHAAwH;EAExH,sEAAsE;EAEtE,uBAAuB;EACvB,0CAA0C;AAC5C;AACA;EACE,KAAK,yBAAyB,EAAE;AAClC;AACA;EACE,+EAA+E;AACjF;AACA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,gBAAgB,cAAc,EAAE,eAAe,EAAE;AACjD,kBAAkB,gBAAgB,EAAE,mBAAmB,EAAE;AACzD,gBAAgB,oBAAoB,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEvE;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qDAAqD;EACrD,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,WAAW,mBAAmB,EAAE,YAAY,EAAE;EAC9C,MAAM,qBAAqB,EAAE,YAAY,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;;AAErD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,wBAAwB,EAAE;EAC7C,KAAK,UAAU,EAAE,2BAA2B,EAAE;AAChD;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,8EAA8E;EAC9E,gDAAgD;AAClD;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,WAAW,qCAAqC,EAAE;EAClD,MAAM,qCAAqC,EAAE;AAC/C;;AAEA;EACE,WAAW,mBAAmB,EAAE,8EAA8E,EAAE;EAChH,MAAM,sBAAsB,EAAE,+EAA+E,EAAE;AACjH;;AAEA;EACE,WAAW,sCAAsC,EAAE;EACnD,MAAM,uCAAuC,EAAE;AACjD;;AAEA;EACE,WAAW,2CAA2C,EAAE;EACxD,MAAM,2CAA2C,EAAE;AACrD;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,WAAW;EACX,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;EACE,KAAK,oBAAoB,EAAE;AAC7B;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,KAAK,mBAAmB,EAAE,UAAU,EAAE;AACxC;AACA;EACE,UAAU,UAAU,EAAE;EACtB,OAAO,UAAU,EAAE;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,wCAAwC;AAC1C;AACA;EACE,KAAK,qBAAqB,EAAE,UAAU,EAAE;EACxC,MAAM,mBAAmB,EAAE,UAAU,EAAE;EACvC,OAAO,qBAAqB,EAAE,UAAU,EAAE;AAC5C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,KAAK,mBAAmB,EAAE,UAAU,EAAE;AACxC;AACA;EACE,KAAK,UAAU,EAAE;EACjB,OAAO,UAAU,EAAE;AACrB;;AAEA,UAAU;AACV;EACE,kCAAkC;AACpC;;AAEA,mBAAmB;AACnB;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,0BAA0B;EAC1B,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;;AAExD;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;;AAErD;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,UAAU;EACV,kDAAkD;AACpD;AACA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;AACA;EACE,oBAAoB,eAAe,EAAE,UAAU,EAAE;AACnD;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,yCAAyC;EACzC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA,eAAe,qBAAqB,EAAE,sBAAsB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AAC9H,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,aAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,kBAAkB;AACpB;;;AAGA;;iDAEiD;;AAEjD;EACE;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,aAAa;EACf;AACF;AACA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":["/* ============================================\r\n   HealthMonitorApp.css - Medical AI Theme\r\n   ============================================ */\r\n\r\n.hm-app {\r\n  background: #F8FAFC;\r\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\r\n}\r\n\r\n.hm-container {\r\n  max-width: 1100px;\r\n  margin: 0 auto;\r\n  padding: 1.5rem;\r\n}\r\n\r\n/* Hero */\r\n.hm-hero {\r\n  text-align: center;\r\n  padding: 1.5rem 0 1rem;\r\n}\r\n\r\n.hm-hero-icon {\r\n  width: 56px;\r\n  height: 56px;\r\n  border-radius: 1rem;\r\n  background: linear-gradient(135deg, #0F766E, #14B8A6);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #fff;\r\n  margin-bottom: 0.75rem;\r\n  box-shadow: 0 8px 20px rgba(15, 118, 110, 0.25);\r\n  animation: heroFloat 3s ease-in-out infinite;\r\n}\r\n\r\n@keyframes heroFloat {\r\n  0%, 100% { transform: translateY(0); }\r\n  50% { transform: translateY(-6px); }\r\n}\r\n\r\n/* ============================================\r\n   Camera Loading\r\n   ============================================ */\r\n.hm-camera-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4rem 2rem;\r\n  background: #fff;\r\n  border: 1px solid #E2E8F0;\r\n  border-radius: 1rem;\r\n  gap: 1.25rem;\r\n}\r\n.hm-loading-spinner {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 50%;\r\n  border: 4px solid #E2E8F0;\r\n  border-top-color: #0F766E;\r\n  animation: spin 0.8s linear infinite;\r\n}\r\n.hm-loading-text {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: #475569;\r\n}\r\n\r\n/* ============================================\r\n   Camera Fade In / Video Fade In\r\n   ============================================ */\r\n.hm-camera-enter {\r\n  animation: cameraFadeIn 700ms ease forwards;\r\n}\r\n.hm-video-enter {\r\n  animation: videoFadeIn 700ms ease forwards;\r\n}\r\n@keyframes cameraFadeIn {\r\n  from { opacity: 0; transform: scale(0.95); }\r\n  to { opacity: 1; transform: scale(1); }\r\n}\r\n@keyframes videoFadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n/* ============================================\r\n   Camera Border Gradient\r\n   ============================================ */\r\n.hm-camera-border {\r\n  position: absolute;\r\n  inset: -2px;\r\n  border-radius: inherit;\r\n  z-index: 1;\r\n  pointer-events: none;\r\n}\r\n.hm-camera-border::before {\r\n  content: '';\r\n  position: absolute;\r\n  inset: 0;\r\n  border-radius: inherit;\r\n  padding: 2px;\r\n  background: conic-gradient(from 0deg, transparent, rgba(20,184,166,0.3), transparent, rgba(20,184,166,0.7), transparent);\r\n  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\r\n  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\r\n  -webkit-mask-composite: xor;\r\n  mask-composite: exclude;\r\n  animation: borderRotate 4s linear infinite;\r\n}\r\n@keyframes borderRotate {\r\n  to { transform: rotate(360deg); }\r\n}\r\n.hm-border-pulse::before {\r\n  animation: borderRotate 4s linear infinite, borderPulse 2s ease-in-out infinite;\r\n}\r\n@keyframes borderPulse {\r\n  0%, 100% { opacity: 0.6; }\r\n  50% { opacity: 1; }\r\n}\r\n\r\n.hm-hero-title {\r\n  font-size: 2rem;\r\n  font-weight: 800;\r\n  color: #0F172A;\r\n  letter-spacing: -0.5px;\r\n}\r\n\r\n.hm-hero-sub {\r\n  font-size: 0.9375rem;\r\n  color: #64748B;\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n/* Error */\r\n.hm-error {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.75rem;\r\n  padding: 1rem;\r\n  background: #FEF2F2;\r\n  border: 1px solid #FECACA;\r\n  border-radius: 0.75rem;\r\n  margin-bottom: 1.25rem;\r\n  color: #DC2626;\r\n}\r\n\r\n.hm-error svg { flex-shrink: 0; margin-top: 2px; }\r\n.hm-error-title { font-weight: 600; font-size: 0.875rem; }\r\n.hm-error-msg { font-size: 0.8125rem; color: #B91C1C; margin-top: 2px; }\r\n\r\n/* ============================================\r\n   Idle State\r\n   ============================================ */\r\n\r\n.hm-idle {\r\n  text-align: center;\r\n  background: #fff;\r\n  border: 1px solid #E2E8F0;\r\n  border-radius: 1rem;\r\n  padding: 3rem 2rem;\r\n}\r\n\r\n.hm-idle-icon-wrap {\r\n  position: relative;\r\n  display: inline-block;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.hm-idle-icon-bg {\r\n  position: absolute;\r\n  inset: -8px;\r\n  background: linear-gradient(135deg, #CCFBF1, #99F6E4);\r\n  border-radius: 50%;\r\n  opacity: 0.5;\r\n  animation: iconPulse 2.5s ease-in-out infinite;\r\n}\r\n\r\n@keyframes iconPulse {\r\n  0%, 100% { transform: scale(1); opacity: 0.5; }\r\n  50% { transform: scale(1.1); opacity: 0.3; }\r\n}\r\n\r\n.hm-idle-icon {\r\n  position: relative;\r\n  color: #0F766E;\r\n}\r\n\r\n.hm-idle-title {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: #0F172A;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.hm-idle-desc {\r\n  color: #64748B;\r\n  font-size: 0.9375rem;\r\n  max-width: 480px;\r\n  margin: 0 auto 1.75rem;\r\n  line-height: 1.65;\r\n}\r\n\r\n/* Features Grid */\r\n.hm-features {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 1rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.hm-feature {\r\n  padding: 1.25rem;\r\n  background: #F8FAFC;\r\n  border: 1px solid #F1F5F9;\r\n  border-radius: 0.75rem;\r\n  transition: all 0.25s ease;\r\n}\r\n\r\n.hm-feature:hover {\r\n  background: #fff;\r\n  border-color: #E2E8F0;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.hm-feature-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 0.625rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 0.75rem;\r\n}\r\n\r\n.hm-feature-1 { background: #FEF2F2; color: #DC2626; }\r\n.hm-feature-2 { background: #EFF6FF; color: #2563EB; }\r\n.hm-feature-3 { background: #F5F3FF; color: #7C3AED; }\r\n.hm-feature-4 { background: #FFFBEB; color: #D97706; }\r\n\r\n.hm-feature-title {\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  color: #0F172A;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.hm-feature-desc {\r\n  font-size: 0.75rem;\r\n  color: #64748B;\r\n}\r\n\r\n/* ============================================\r\n   Buttons\r\n   ============================================ */\r\n\r\n.hm-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 0.625rem;\r\n  font-size: 0.9375rem;\r\n  font-weight: 600;\r\n  font-family: 'Inter', system-ui, sans-serif;\r\n  cursor: pointer;\r\n  border: none;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.hm-btn-primary {\r\n  background: linear-gradient(135deg, #0F766E, #0D9488);\r\n  color: #fff;\r\n  box-shadow: 0 4px 14px rgba(15, 118, 110, 0.3);\r\n}\r\n\r\n.hm-btn-primary:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 6px 20px rgba(15, 118, 110, 0.4);\r\n}\r\n\r\n.hm-btn-secondary {\r\n  background: #F1F5F9;\r\n  color: #475569;\r\n  border: 1px solid #E2E8F0;\r\n}\r\n\r\n.hm-btn-secondary:hover {\r\n  background: #E2E8F0;\r\n}\r\n\r\n.hm-btn-record {\r\n  background: linear-gradient(135deg, #DC2626, #B91C1C);\r\n  color: #fff;\r\n  box-shadow: 0 4px 14px rgba(220, 38, 38, 0.3);\r\n}\r\n\r\n.hm-btn-record:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 6px 20px rgba(220, 38, 38, 0.4);\r\n}\r\n\r\n.hm-btn-group {\r\n  display: flex;\r\n  gap: 0.75rem;\r\n  justify-content: center;\r\n}\r\n\r\n.hm-record-dot {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  background: #fff;\r\n}\r\n\r\n/* ============================================\r\n   Camera State\r\n   ============================================ */\r\n\r\n.hm-camera, .hm-recording {\r\n  position: relative;\r\n  background: #fff;\r\n  border: 1px solid #E2E8F0;\r\n  border-radius: 1rem;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Instruction Banner */\r\n.hm-instruction-banner {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.75rem;\r\n  width: fit-content;\r\n  margin: 1rem auto;\r\n  padding: 1rem 2rem;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\r\n  font-weight: 500;\r\n  font-size: 1rem;\r\n  color: #0F172A;\r\n  animation: slideUpFadeIn 0.5s ease forwards;\r\n}\r\n\r\n.hm-instruction-icon {\r\n  font-size: 1.5rem;\r\n  line-height: 1;\r\n}\r\n\r\n.hm-instruction-text {\r\n  animation: slideUpFadeIn 0.5s ease forwards;\r\n}\r\n\r\n@keyframes slideUpFadeIn {\r\n  from { opacity: 0; transform: translateY(12px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n@keyframes slideUpFadeOut {\r\n  from { opacity: 1; transform: translateY(0); }\r\n  to { opacity: 0; transform: translateY(-8px); }\r\n}\r\n\r\n/* Watermark Logo */\r\n.hm-watermark {\r\n  position: absolute;\r\n  top: 0.75rem;\r\n  right: 0.75rem;\r\n  width: 64px;\r\n  height: 64px;\r\n  opacity: 0.35;\r\n  pointer-events: none;\r\n  z-index: 5;\r\n}\r\n\r\n.hm-hint-banner {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.5rem;\r\n  padding: 0.75rem;\r\n  background: #FEF3C7;\r\n  border: 1px solid #FDE68A;\r\n  border-radius: 0.625rem;\r\n  margin-bottom: 0.75rem;\r\n  font-size: 0.8125rem;\r\n  color: #92400E;\r\n  line-height: 1.5;\r\n}\r\n\r\n.hm-hint-banner svg {\r\n  flex-shrink: 0;\r\n  color: #D97706;\r\n  margin-top: 2px;\r\n}\r\n\r\n.hm-video-wrap {\r\n  position: relative;\r\n  background: #000;\r\n}\r\n\r\n.hm-video {\r\n  width: 100%;\r\n  height: 420px;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\n\r\n.hm-video-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  pointer-events: none;\r\n}\r\n\r\n.hm-face-guide {\r\n  width: 16rem;\r\n  height: 20rem;\r\n  border: 3px solid rgba(20, 184, 166, 0.5);\r\n  border-radius: 50%;\r\n  animation: guidePulse 2.5s ease-in-out infinite;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.hm-face-guide.face-detected {\r\n  border-color: rgba(20, 184, 166, 0.8);\r\n  box-shadow: 0 0 20px rgba(20, 184, 166, 0.3), 0 0 40px rgba(20, 184, 166, 0.1);\r\n  animation: guideDetected 2s ease-in-out infinite;\r\n}\r\n\r\n.hm-face-guide.face-not-detected {\r\n  border-color: rgba(148, 163, 184, 0.4);\r\n  box-shadow: none;\r\n  animation: guideNotFound 2s ease-in-out infinite;\r\n}\r\n\r\n.hm-face-guide.face-recording {\r\n  border-color: rgba(239, 68, 68, 0.6);\r\n  box-shadow: 0 0 15px rgba(239, 68, 68, 0.3);\r\n  animation: recGlow 2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes guidePulse {\r\n  0%, 100% { border-color: rgba(20, 184, 166, 0.5); }\r\n  50% { border-color: rgba(20, 184, 166, 0.2); }\r\n}\r\n\r\n@keyframes guideDetected {\r\n  0%, 100% { transform: scale(1); box-shadow: 0 0 20px rgba(20, 184, 166, 0.3), 0 0 40px rgba(20, 184, 166, 0.1); }\r\n  50% { transform: scale(1.02); box-shadow: 0 0 30px rgba(20, 184, 166, 0.2), 0 0 50px rgba(20, 184, 166, 0.05); }\r\n}\r\n\r\n@keyframes guideNotFound {\r\n  0%, 100% { border-color: rgba(148, 163, 184, 0.4); }\r\n  50% { border-color: rgba(148, 163, 184, 0.15); }\r\n}\r\n\r\n@keyframes recGlow {\r\n  0%, 100% { box-shadow: 0 0 15px rgba(239, 68, 68, 0.3); }\r\n  50% { box-shadow: 0 0 25px rgba(239, 68, 68, 0.1); }\r\n}\r\n\r\n/* Looking for face */\r\n.hm-looking-text {\r\n  position: absolute;\r\n  bottom: 3rem;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  color: rgba(255, 255, 255, 0.8);\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  background: rgba(0, 0, 0, 0.55);\r\n  backdrop-filter: blur(4px);\r\n  padding: 0.5rem 1.25rem;\r\n  border-radius: 2rem;\r\n  white-space: nowrap;\r\n  animation: pulseText 2s ease-in-out infinite;\r\n  z-index: 10;\r\n}\r\n\r\n@keyframes pulseText {\r\n  0%, 100% { opacity: 0.7; }\r\n  50% { opacity: 1; }\r\n}\r\n\r\n/* Scan Ready Overlay */\r\n.hm-scan-ready {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(0, 0, 0, 0.45);\r\n  z-index: 20;\r\n  animation: scanReadyFade 2.2s ease forwards;\r\n}\r\n.hm-scan-ready-inner {\r\n  text-align: center;\r\n  color: #fff;\r\n  animation: scanReadyScale 0.5s ease;\r\n}\r\n.hm-ready-checkmark {\r\n  width: 72px;\r\n  height: 72px;\r\n  border-radius: 50%;\r\n  background: rgba(16, 185, 129, 0.2);\r\n  border: 3px solid rgba(16, 185, 129, 0.8);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 0.75rem;\r\n}\r\n.hm-check-path {\r\n  stroke-dasharray: 30;\r\n  stroke-dashoffset: 30;\r\n  animation: drawCheck 0.6s ease forwards 0.1s;\r\n}\r\n@keyframes drawCheck {\r\n  to { stroke-dashoffset: 0; }\r\n}\r\n.hm-ready-text {\r\n  font-size: 1.125rem;\r\n  font-weight: 700;\r\n}\r\n@keyframes scanReadyScale {\r\n  from { transform: scale(0.8); opacity: 0; }\r\n  to { transform: scale(1); opacity: 1; }\r\n}\r\n@keyframes scanReadyFade {\r\n  0%, 60% { opacity: 1; }\r\n  100% { opacity: 0; }\r\n}\r\n\r\n/* Countdown Overlay */\r\n.hm-countdown-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 25;\r\n  background: rgba(0, 0, 0, 0.2);\r\n}\r\n.hm-countdown-number {\r\n  font-size: 6rem;\r\n  font-weight: 800;\r\n  color: #fff;\r\n  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);\r\n  animation: countdownPop 1s ease forwards;\r\n}\r\n@keyframes countdownPop {\r\n  0% { transform: scale(1.5); opacity: 0; }\r\n  40% { transform: scale(1); opacity: 1; }\r\n  100% { transform: scale(0.8); opacity: 0; }\r\n}\r\n\r\n/* Recording Complete */\r\n.hm-recording-complete {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4rem 2rem;\r\n  background: #fff;\r\n  border: 1px solid #E2E8F0;\r\n  border-radius: 1rem;\r\n  animation: completeFade 1.5s ease forwards;\r\n}\r\n.hm-complete-inner {\r\n  text-align: center;\r\n  animation: completeScale 0.5s ease;\r\n}\r\n.hm-complete-check {\r\n  width: 72px;\r\n  height: 72px;\r\n  border-radius: 50%;\r\n  background: rgba(16, 185, 129, 0.15);\r\n  border: 3px solid #10B981;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 0.75rem;\r\n}\r\n.hm-complete-check .hm-check-path {\r\n  stroke-dasharray: 30;\r\n  stroke-dashoffset: 30;\r\n  animation: drawCheck 0.6s ease forwards 0.1s;\r\n}\r\n.hm-complete-text {\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n  color: #059669;\r\n}\r\n@keyframes completeScale {\r\n  from { transform: scale(0.8); opacity: 0; }\r\n  to { transform: scale(1); opacity: 1; }\r\n}\r\n@keyframes completeFade {\r\n  0% { opacity: 0; }\r\n  100% { opacity: 1; }\r\n}\r\n\r\n/* Timer */\r\n.hm-timer-val {\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n/* Reduced Motion */\r\n@media (prefers-reduced-motion: reduce) {\r\n  *, *::before, *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n  }\r\n}\r\n\r\n.hm-badge {\r\n  position: absolute;\r\n  top: 1rem;\r\n  left: 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: rgba(0, 0, 0, 0.6);\r\n  backdrop-filter: blur(4px);\r\n  color: #fff;\r\n  padding: 0.375rem 0.875rem;\r\n  border-radius: 2rem;\r\n  font-size: 0.8125rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.hm-badge-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #10B981;\r\n  animation: dotPulse 2s ease-in-out infinite;\r\n}\r\n\r\n.hm-badge-dot-red {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #EF4444;\r\n  animation: dotPulse 1s ease-in-out infinite;\r\n}\r\n\r\n@keyframes dotPulse {\r\n  0%, 100% { opacity: 1; }\r\n  50% { opacity: 0.4; }\r\n}\r\n\r\n.hm-timer-overlay {\r\n  position: absolute;\r\n  bottom: 1rem;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  color: #fff;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 2rem;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.hm-timer-val {\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.hm-timer-total {\r\n  color: #94A3B8;\r\n}\r\n\r\n.hm-camera-controls {\r\n  padding: 1.25rem;\r\n  text-align: center;\r\n}\r\n\r\n.hm-camera-hint {\r\n  color: #475569;\r\n  font-size: 0.9375rem;\r\n  font-weight: 500;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n/* Recording */\r\n.hm-recording .hm-video {\r\n  height: 380px;\r\n}\r\n\r\n.hm-recording-hint {\r\n  text-align: center;\r\n  color: #64748B;\r\n  font-size: 0.875rem;\r\n  padding: 0.75rem;\r\n}\r\n\r\n/* Progress Bar */\r\n.hm-progress-wrap {\r\n  padding: 0 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.hm-progress-bar {\r\n  flex: 1;\r\n  height: 6px;\r\n  background: #E2E8F0;\r\n  border-radius: 3px;\r\n  overflow: hidden;\r\n}\r\n\r\n.hm-progress-fill {\r\n  height: 100%;\r\n  background: linear-gradient(90deg, #0F766E, #14B8A6);\r\n  border-radius: 3px;\r\n  transition: width 0.5s ease;\r\n}\r\n\r\n.hm-progress-animated {\r\n  background: linear-gradient(90deg, #0F766E, #14B8A6, #0F766E);\r\n  background-size: 200% 100%;\r\n  animation: progressShimmer 2s linear infinite;\r\n}\r\n\r\n@keyframes progressShimmer {\r\n  0% { background-position: 200% 0; }\r\n  100% { background-position: -200% 0; }\r\n}\r\n\r\n.hm-progress-text {\r\n  font-size: 0.8125rem;\r\n  font-weight: 600;\r\n  color: #475569;\r\n  min-width: 3rem;\r\n}\r\n\r\n/* ============================================\r\n   Processing State\r\n   ============================================ */\r\n\r\n.hm-processing {\r\n  text-align: center;\r\n  background: #fff;\r\n  border: 1px solid #E2E8F0;\r\n  border-radius: 1rem;\r\n  padding: 3rem 2rem;\r\n}\r\n\r\n.hm-processing-spinner {\r\n  width: 64px;\r\n  height: 64px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, #F0FDF4, #CCFBF1);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 1.25rem;\r\n}\r\n\r\n.hm-spin-icon {\r\n  color: #0F766E;\r\n  animation: spin 1.5s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.hm-processing-title {\r\n  font-size: 1.375rem;\r\n  font-weight: 700;\r\n  color: #0F172A;\r\n  margin-bottom: 0.375rem;\r\n}\r\n\r\n.hm-processing-desc {\r\n  color: #64748B;\r\n  font-size: 0.9375rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.hm-elapsed {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.375rem;\r\n  color: #94A3B8;\r\n  font-size: 0.8125rem;\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n/* ============================================\r\n   Results State\r\n   ============================================ */\r\n\r\n.hm-results {\r\n  background: #fff;\r\n  border: 1px solid #E2E8F0;\r\n  border-radius: 1rem;\r\n  padding: 2rem;\r\n}\r\n\r\n.hm-results-header {\r\n  text-align: center;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.hm-success-icon {\r\n  width: 56px;\r\n  height: 56px;\r\n  border-radius: 50%;\r\n  background: #F0FDF4;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 0.75rem;\r\n  color: #059669;\r\n}\r\n\r\n.hm-results-title {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: #0F172A;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.hm-results-sub {\r\n  font-size: 0.9375rem;\r\n  color: #64748B;\r\n}\r\n\r\n/* Patient Info Banner */\r\n.hm-patient-info {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n  background: #F0FDF4;\r\n  border: 1px solid #A7F3D0;\r\n  border-radius: 0.75rem;\r\n  padding: 0.75rem 1rem;\r\n  margin-bottom: 1.5rem;\r\n  font-size: 0.9375rem;\r\n  color: #0F172A;\r\n}\r\n\r\n.hm-patient-info-name {\r\n  font-weight: 700;\r\n  color: #0F766E;\r\n}\r\n\r\n.hm-patient-info-sep {\r\n  color: #94A3B8;\r\n}\r\n\r\n/* Vital Cards Grid */\r\n.hm-results-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 1rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.hm-vital-card {\r\n  padding: 1.25rem;\r\n  border-radius: 0.875rem;\r\n  border: 1px solid #E2E8F0;\r\n  background: #fff;\r\n  transition: all 0.25s ease;\r\n}\r\n\r\n.hm-vital-card:hover {\r\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.hm-vital-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.hm-vital-card-1 .hm-vital-header svg { color: #DC2626; }\r\n.hm-vital-card-2 .hm-vital-header svg { color: #F97316; }\r\n.hm-vital-card-3 .hm-vital-header svg { color: #10B981; }\r\n.hm-vital-card-4 .hm-vital-header svg { color: #3B82F6; }\r\n.hm-vital-card-5 .hm-vital-header svg { color: #8B5CF6; }\r\n.hm-vital-card-6 .hm-vital-header svg { color: #F59E0B; }\r\n.hm-vital-card-7 .hm-vital-header svg { color: #EC4899; }\r\n.hm-vital-card-8 .hm-vital-header svg { color: #6366F1; }\r\n\r\n.hm-status-badge {\r\n  font-size: 0.6875rem;\r\n  padding: 0.2rem 0.5rem;\r\n  border-radius: 2rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.status-normal { background: #F0FDF4; color: #059669; }\r\n.status-warning { background: #FEF3C7; color: #D97706; }\r\n.status-info { background: #EFF6FF; color: #2563EB; }\r\n.status-muted { background: #F1F5F9; color: #94A3B8; }\r\n\r\n.hm-vital-label {\r\n  font-size: 0.8125rem;\r\n  font-weight: 600;\r\n  color: #475569;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.hm-vital-value {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 0.375rem;\r\n}\r\n\r\n.hm-vital-number {\r\n  font-size: 1.75rem;\r\n  font-weight: 800;\r\n  color: #0F172A;\r\n  letter-spacing: -0.5px;\r\n}\r\n\r\n.hm-vital-unit {\r\n  font-size: 0.8125rem;\r\n  color: #94A3B8;\r\n  font-weight: 500;\r\n}\r\n\r\n/* ============================================\r\n   Radar Chart Section\r\n   ============================================ */\r\n.hm-radar-section {\r\n  display: flex;\r\n  gap: 1.5rem;\r\n  margin-bottom: 1.5rem;\r\n  background: #fff;\r\n  border: 1px solid #E2E8F0;\r\n  border-radius: 0.875rem;\r\n  padding: 1.5rem;\r\n}\r\n.hm-radar-polygon {\r\n  opacity: 0;\r\n  animation: hmRadarGrow 1.5s ease-out 0.2s forwards;\r\n}\r\n@keyframes hmRadarGrow {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n  .hm-radar-polygon { animation: none; opacity: 1; }\r\n}\r\n.hm-radar-chart-wrap {\r\n  flex: 0 0 60%;\r\n}\r\n.hm-radar-title {\r\n  font-size: 1.0625rem;\r\n  font-weight: 700;\r\n  color: #0F172A;\r\n  margin-bottom: 0.25rem;\r\n}\r\n.hm-radar-sub {\r\n  font-size: 0.8125rem;\r\n  color: #94A3B8;\r\n  margin-bottom: 0.75rem;\r\n}\r\n.hm-summary-wrap {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  padding-left: 1.5rem;\r\n  border-left: 1px solid #E2E8F0;\r\n}\r\n.hm-summary-title {\r\n  font-size: 1.0625rem;\r\n  font-weight: 700;\r\n  color: #0F172A;\r\n  margin-bottom: 0.75rem;\r\n}\r\n.hm-summary-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0 0 1.25rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n.hm-summary-item {\r\n  position: relative;\r\n  padding-left: 1.25rem;\r\n  font-size: 0.8125rem;\r\n  color: #475569;\r\n  line-height: 1.5;\r\n}\r\n.hm-summary-item::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: 0;\r\n  top: 7px;\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n  background: #0F766E;\r\n  opacity: 0.6;\r\n}\r\n.hm-wellness-wrap {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 120px;\r\n  height: 120px;\r\n  margin: 0 auto 0.5rem;\r\n}\r\n.hm-wellness-ring {\r\n  position: absolute;\r\n  inset: 0;\r\n}\r\n.hm-wellness-score {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  line-height: 1;\r\n}\r\n.hm-wellness-num {\r\n  font-size: 2rem;\r\n  font-weight: 800;\r\n  color: #0F172A;\r\n}\r\n.hm-wellness-total {\r\n  font-size: 0.75rem;\r\n  color: #94A3B8;\r\n  font-weight: 600;\r\n}\r\n.hm-wellness-label {\r\n  text-align: center;\r\n  font-size: 0.75rem;\r\n  color: #94A3B8;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Radar Tooltip */\r\n.hm-radar-tooltip {\r\n  background: #fff;\r\n  border: 1px solid #E2E8F0;\r\n  border-radius: 0.625rem;\r\n  padding: 0.75rem 1rem;\r\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\r\n  max-width: 200px;\r\n}\r\n.hm-rt-icon {\r\n  font-size: 1.25rem;\r\n  margin-bottom: 0.25rem;\r\n}\r\n.hm-rt-name {\r\n  font-size: 0.875rem;\r\n  font-weight: 700;\r\n  color: #0F172A;\r\n  margin-bottom: 0.25rem;\r\n}\r\n.hm-rt-value {\r\n  font-size: 1.25rem;\r\n  font-weight: 800;\r\n  color: #0F172A;\r\n}\r\n.hm-rt-unit {\r\n  font-size: 0.75rem;\r\n  color: #94A3B8;\r\n  font-weight: 500;\r\n}\r\n.hm-rt-status {\r\n  font-size: 0.75rem;\r\n  color: #64748B;\r\n  margin-top: 0.25rem;\r\n}\r\n.hm-rt-badge { display: inline-block; padding: 0.1rem 0.4rem; border-radius: 0.25rem; font-weight: 600; font-size: 0.6875rem; }\r\n.hm-rt-normal { background: #F0FDF4; color: #059669; }\r\n.hm-rt-elevated { background: #FEF3C7; color: #D97706; }\r\n.hm-rt-low { background: #FEF2F2; color: #DC2626; }\r\n.hm-rt-excellent { background: #ECFDF5; color: #047857; }\r\n.hm-rt-fair { background: #FFFBEB; color: #B45309; }\r\n.hm-rt-range {\r\n  font-size: 0.6875rem;\r\n  color: #94A3B8;\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n/* Scan Details */\r\n.hm-scan-details {\r\n  background: #F8FAFC;\r\n  border: 1px solid #F1F5F9;\r\n  border-radius: 0.75rem;\r\n  padding: 1.25rem;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.hm-scan-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-size: 0.9375rem;\r\n  font-weight: 600;\r\n  color: #0F172A;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.hm-scan-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 1rem;\r\n}\r\n\r\n.hm-scan-label {\r\n  font-size: 0.75rem;\r\n  color: #94A3B8;\r\n  margin-bottom: 0.125rem;\r\n}\r\n\r\n.hm-scan-val {\r\n  font-size: 0.9375rem;\r\n  font-weight: 700;\r\n  color: #0F172A;\r\n}\r\n\r\n/* Disclaimer Banner */\r\n.hm-disclaimer-banner {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.75rem;\r\n  padding: 1rem 1.25rem;\r\n  background: #FFFBEB;\r\n  border: 1px solid #FDE68A;\r\n  border-radius: 0.75rem;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.hm-disclaimer-banner svg {\r\n  flex-shrink: 0;\r\n  color: #D97706;\r\n  margin-top: 2px;\r\n}\r\n\r\n.hm-disclaimer-title {\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  color: #78350F;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.hm-disclaimer-text {\r\n  font-size: 0.8125rem;\r\n  color: #92400E;\r\n  line-height: 1.6;\r\n}\r\n\r\n/* New Scan */\r\n.hm-new-scan {\r\n  text-align: center;\r\n}\r\n\r\n\r\n/* ============================================\r\n   Responsive\r\n   ============================================ */\r\n\r\n@media (max-width: 1024px) {\r\n  .hm-results-grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n  .hm-scan-grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n  .hm-radar-section {\r\n    flex-direction: column;\r\n  }\r\n  .hm-radar-chart-wrap {\r\n    flex: none;\r\n  }\r\n  .hm-summary-wrap {\r\n    padding-left: 0;\r\n    border-left: none;\r\n    border-top: 1px solid #E2E8F0;\r\n    padding-top: 1.25rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .hm-features {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n  .hm-video {\r\n    height: 300px;\r\n  }\r\n  .hm-face-guide {\r\n    width: 12rem;\r\n    height: 16rem;\r\n  }\r\n  .hm-results {\r\n    padding: 1.25rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .hm-features {\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 0.75rem;\r\n  }\r\n  .hm-results-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .hm-scan-grid {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n  .hm-video {\r\n    height: 250px;\r\n  }\r\n}\r\n/* ============================================\r\n   Generate Report Button\r\n   ============================================ */\r\n\r\n.hm-report-wrap {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  padding: 1rem 0 0.25rem;\r\n}\r\n\r\n.hm-report-patient {\r\n  font-size: 0.8125rem;\r\n  color: #64748B;\r\n}\r\n\r\n.hm-report-patient strong {\r\n  color: #0F172A;\r\n}\r\n\r\n.grp-wrap {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.grp-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.55rem;\r\n  padding: 0.85rem 1.75rem;\r\n  background: linear-gradient(135deg, #0F766E, #0D9488);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 0.875rem;\r\n  font-family: inherit;\r\n  font-size: 0.9375rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  box-shadow: 0 4px 14px rgba(15, 118, 110, 0.3);\r\n  transition: opacity 0.2s, transform 0.15s;\r\n}\r\n\r\n.grp-btn:hover:not(:disabled) {\r\n  opacity: 0.92;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.grp-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.grp-spin {\r\n  animation: hmSpin 0.8s linear infinite;\r\n}\r\n\r\n@keyframes hmSpin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.grp-msg {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.45rem;\r\n  font-size: 0.8125rem;\r\n  font-weight: 500;\r\n  padding: 0.5rem 0.9rem;\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.grp-msg.success {\r\n  background: #F0FDF4;\r\n  border: 1px solid #BBF7D0;\r\n  color: #047857;\r\n}\r\n\r\n.grp-msg.error {\r\n  background: #FEF2F2;\r\n  border: 1px solid #FECACA;\r\n  color: #DC2626;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
